var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-list-group',{staticClass:"mb-3 mt-0"},[_c('mdb-list-group-item',{staticClass:"border-primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }